import { render, staticRenderFns } from "./CommissionRateAdjustmentRuleManage.vue?vue&type=template&id=23250a84"
import script from "./CommissionRateAdjustmentRuleManage.vue?vue&type=script&lang=js"
export * from "./CommissionRateAdjustmentRuleManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports